import { useNavigate } from "react-router-dom";
import {
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
} from "@mui/material";
import { MdEdit, MdDelete, MdCheckCircle } from "react-icons/md";
import { useEstablecimientosContext } from "../establecimientos-context";

export function EstablecimientosTable() {
  const navigate = useNavigate();

  const { establecimientos, deleteEstablecimiento, verifyEstablecimiento } =
    useEstablecimientosContext();

  return (
    <Paper
      className="animate__animated animate__fadeIn"
      sx={{ padding: 1 }}
      variant="outlined"
    >
      <Stack>
        <Stack direction="row" justifyContent="space-between" padding={2}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="h6">Establecimientos</Typography>
          </Stack>

          {/* <Button
            variant="contained"
            color="success"
            size="small"
            fullWidth={false}
            onClick={() => navigate("add")}
          >
            Agregar
          </Button> */}
        </Stack>

        {!!establecimientos.length ? (
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {[
                  "#",
                  "Establecimiento",
                  // "Estado",
                  // "Opciones"
                ].map((label, i) => (
                  <TableCell key={i}>{label}</TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {establecimientos.map((establecimiento, i) => (
                <TableRow key={establecimiento.establecimiento_id}>
                  <TableCell>{i + 1}</TableCell>

                  <TableCell>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Typography variant="body2">
                        {`${establecimiento.ciudad_nombre}, ${establecimiento.departamento_nombre}`}
                      </Typography>

                      {!!establecimiento.establecimiento_principal && (
                        <Chip
                          label="Principal"
                          size="small"
                          color="success"
                          variant="outlined"
                        />
                      )}
                    </Stack>

                    <Typography variant="body2">
                      <strong>Dirección detallada: </strong>
                      {establecimiento.establecimiento_direccion_detallada}
                    </Typography>

                    <Typography variant="body2">
                      <b>Coordenadas: </b>
                      {!!establecimiento.establecimiento_coordenadas ? (
                        <a
                          href={`https://www.google.com/maps/search/?api=1&query=${establecimiento.establecimiento_coordenadas}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {establecimiento.establecimiento_coordenadas}
                        </a>
                      ) : (
                        "N/D"
                      )}
                    </Typography>
                  </TableCell>

                  {/* <TableCell>
                    <Chip
                      label={
                        !!establecimiento.establecimiento_verificado
                          ? "Verificado"
                          : "Pendiente"
                      }
                      color={
                        !!establecimiento.establecimiento_verificado
                          ? "success"
                          : "warning"
                      }
                      variant="outlined"
                      size="small"
                    />
                  </TableCell> */}

                  {/* <TableCell align="center">
                    {!establecimiento.establecimiento_verificado ? (
                      <Stack direction="row" justifyContent="center">
                        <Tooltip title="Verificar">
                          <IconButton
                            color="success"
                            size="small"
                            onClick={async () =>
                              await verifyEstablecimiento({
                                establecimientoId:
                                  establecimiento.establecimiento_id,
                              })
                            }
                          >
                            <MdCheckCircle />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Modificar">
                          <IconButton
                            color="warning"
                            size="small"
                            onClick={() =>
                              navigate(
                                `${establecimiento.establecimiento_id}/edit`
                              )
                            }
                          >
                            <MdEdit />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Eliminar">
                          <IconButton
                            color="error"
                            size="small"
                            onClick={async () =>
                              await deleteEstablecimiento({
                                establecimientoId:
                                  establecimiento.establecimiento_id,
                              })
                            }
                          >
                            <MdDelete />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    ) : (
                      "-"
                    )}
                  </TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography align="center" variant="overline">
            Sin establecimientos
          </Typography>
        )}
      </Stack>
    </Paper>
  );
}
